<template>
  <div>
    <!--表单-->
    <van-cell-group class="applyForm">
      <van-field v-model="username" label="联系人" placeholder="请输入联系人姓名" />
      <van-field v-model="phoneNum" label="手机号" placeholder="请输入手机号"></van-field>
      <van-field v-model="codeNum" label="短信验证码" placeholder="请输入短信验证码">
        <van-button slot="button" size="small" class="reg__codeBtn" @click="codeBtn">{{btnTitle}}</van-button>
      </van-field>
      <!--省市区-->
      <van-field v-model="area" label="选择地区" placeholder="请选择省市区" @click="showPopup" right-icon="arrow" />
      <van-popup v-model="show" position="bottom">
        <van-area :area-list="areaList" @confirm="checkArea" @cancel="show = false" />
      </van-popup>

      <van-field v-model="addressDetails" rows="1" autosize label="详细地址" type="textarea" placeholder="请输入街道门牌" />
      <van-cell title="是否有门店" center value-class="bookOrder__switch">
        <van-switch v-model="checked" @click="storeName=''" active-color="#45B9BC" size="26px"/>
      </van-cell>
      <van-field v-model="storeName" v-if="checked===true" label="门店名称" placeholder="请输入门店名称" />
    </van-cell-group>
    <div class="sureBtn__box"><button @click="submitBtn">提交申请</button></div>
  </div>
</template>

<script>
  import areaList from "@/assets/js/areaList"
  var phoneNum_reg=/^(((13[0-9]{1})|(14[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;   //手机号正则
  export default {
    name: "partnerApply",
    data(){
      return{
        username:'',  //联系人
        phoneNum:'',  //手机号
        codeNum:'',  //验证码
        btnTitle:'获取验证码',   //获取验证码
        addressDetails:'',   //详细地址
        storeName:'',  //门店
        area:'',  //选择地区
        show: false,   //省市区弹出层
        areaList,    //省市区组件
        regionPicker: false,
        checked:true,   //是否有门店-开关
      }
    },
    methods: {
      // 省市区弹出层
      showPopup() {
        this.show = true;
      },
      //省市区弹出层-确认按钮
      checkArea(value){
        this.show = false;
        this.area=value[0].name+' '+value[1].name+' '+value[2].name;
      },

      // 提交按钮
      submitBtn(){
        if(!this.username){
          this.$toast('请输入联系人姓名！');
          return false
        }
        if(!this.phoneNum){
          this.$toast('请输入手机号！');
          return false
        }
        if (!phoneNum_reg.test(this.phoneNum)) {
          this.$toast('手机号格式不正确');
          return false
        }
        if(!this.codeNum){
          this.$toast('请输入验证码！');
          return false
        }
        if(!this.area){
          this.$toast('请输入地区！');
          return false
        }
        if(!this.addressDetails){
          this.$toast('请输入街道门牌！');
          return false
        }
        if(this.checked&&!this.storeName){
          this.$toast('请输入门店名称');
          return false
        }
        var data  ={
          realname:this.username,  //联系人
          mobile:this.phoneNum,  //手机号
          codeNum:this.codeNum,  //验证码
          address:this.addressDetails,   //详细地址
          storeName:this.storeName,  //门店
          area:this.area,  //选择地区
        }
        this.axios({
          url: this.api.member.maker_apply, 
          data: data
        }).then(res => {
          if (res.error === 0) {
            let that = this;
            this.$toast({
              message:res.message,
              duration:1500,
              onClose:function(){
                  that.$router.push({path:'index'});
              }
            })
          }
        });
        },
      // 发送验证码
      codeBtn(){
        if(!this.phoneNum){
          this.$toast('请输入手机号！');
          return false
        }
        if (!phoneNum_reg.test(this.phoneNum)) {
          this.$toast('手机号格式不正确');
          return false
        }
        if(!this.disabled) {
          //倒计时
          let time = 60;
          let timer = setInterval(() => {
            if (time == 0) {
              clearInterval(timer);
              this.disabled = false;
              this.btnTitle = "获取验证码";
            } else {
              this.btnTitle = time + '秒后重试';
              this.disabled = true;
              time--;

            }
          }, 1000);
        }
      },
    }
  }
</script>

<style scoped>
  .applyForm{
    margin-bottom: 1rem;
  }
  .applyForm .van-cell{
    align-items: center;
    -webkit-align-items: center;
    padding: .5rem .75rem;
    line-height: 1.2rem;
    font-size: .7rem;
  }
  .reg__codeBtn{
    padding-left: 0;
    border: 1px solid rgba(69, 185, 188, .5);
    border-radius: .15rem;
  }
  .reg__codeBtn .van-button__text{
    padding-left: .5rem;
    color: #45B9BC;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/partnerApply.vue